import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobs } from '../behavior/jobs-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { calcPercentFrame } from '../indicators/fullnessIndicators'
import { assert } from '../lib/assert-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IMachine } from './machines'
import { getContext } from '../main/scene'
import { common } from '../main/common-sidecar'

import { machines } from './machines-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'grower')
}

const growRate = 5

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  let jc = jobCreators.create(
    () => {
      if (obj.waterSupply > 0) {
        return false
      }
      if (!cargoes.existsOfType('water')) {
        return false
      }
      return true
    },
    () => {
      let j = jobs.create('fill-water')
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)

  jc = jobCreators.create(
    () => {
      if (obj.progress >= 100) {
        return true
      }
      return false
    },
    () => {
      let j = jobs.create('harvest')
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)

  if (obj.waterSupply <= 0) {
    spriteMap.setFrame(obj.image, obj.data.frames[0])
  } else {
    spriteMap.setFrame(obj.image, obj.data.frames[1])
  }

  if (obj.waterSupply > 0) {
    obj.progress += growRate * common.getUpdateDeltaScaled()

    let numFrames = 5
    let f = calcPercentFrame(numFrames, obj.progress, 100)
    spriteMap.setFrame(obj.image, obj.data.frames[1 + f])
  }

  if (obj.progress >= 100) {
  }
}
